import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import SearchBarSection from './SearchBarSection';
import { getSectionPropsByType } from '../../utils/sharedSearchBarHelpers';
import { injectIntl, intlShape } from 'react-intl';

import styles from './SearchBar-style.scss';

const SearchBarOverlay = ({ visible, suggestions, handleRowClick, cursorHighlightId, intl }) => {
    const overlayClasses = classnames({
        [styles.overlay]: true,
        [styles.isVisible]: visible,
    });

    if (!suggestions) {
        return null;
    }

    return (
        <div className={overlayClasses}>
            {suggestions.map(section => {
                const { title, urlSection } = getSectionPropsByType(section.type, intl);
                const { terms, type } = section;
                return terms && terms.length ? (
                    <SearchBarSection
                        key={title}
                        title={title}
                        type={type}
                        urlSection={urlSection}
                        terms={terms}
                        handleRowClick={handleRowClick}
                        cursorHighlightId={cursorHighlightId}
                    />
                ) : null;
            })}
        </div>
    );
};

SearchBarOverlay.propTypes = {
    visible: PropTypes.bool,
    suggestions: PropTypes.array,
    handleRowClick: PropTypes.func,
    cursorHighlightId: PropTypes.string,
    intl: intlShape,
};

export default injectIntl(SearchBarOverlay);
